import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { SpinnerModule } from '@spartacus/storefront';
import { CartNotEmptyGuard, CheckoutAuthGuard, CheckoutDeliveryModeModule } from '@spartacus/checkout/base/components';
import { AtgCheckoutDeliveryModeComponent } from './atg-checkout-delivery-mode.component';

@NgModule({
  declarations: [AtgCheckoutDeliveryModeComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    SpinnerModule,
    I18nModule,
    CheckoutDeliveryModeModule,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CheckoutDeliveryMode: {
          component: AtgCheckoutDeliveryModeComponent,
          data: {
            composition: {
              inner: ['PickupInStoreDeliveryModeComponent'],
            },
          },
          guards: [CheckoutAuthGuard, CartNotEmptyGuard],
        },
      },
    }),
  ],
  exports: [AtgCheckoutDeliveryModeComponent]
})
export class AtgCheckoutDeliveryModeModule { }
